import { DocumentUploadAccountTypes } from '@interfaces/models/doc-upload-types';

import { IDocumentRequirementsList } from '../models';

export function generateDocRequirementsList(
  selectedAccountTypes: string[],
  content: any,
  isDeathVerified: boolean,
): IDocumentRequirementsList[] {
  if (!content || !selectedAccountTypes.length) {
    return [];
  }
  const requirementsSteps = selectedAccountTypes
    .map((type) => {
      switch (type) {
        case DocumentUploadAccountTypes.IRA:
          return content.ira;
        case DocumentUploadAccountTypes.ESTATE:
          return content.estate;
        case DocumentUploadAccountTypes.TRUST_UNDER_AGREEMENT:
          return content.trustUnderAgreement;
        case DocumentUploadAccountTypes.TRUST_UNDER_WILL:
          return content.trustUnderWill;
        default:
          return undefined;
      }
    })
    .filter(Boolean) as IDocumentRequirementsList[];
  return !isDeathVerified ? [content.allTypes, ...requirementsSteps] : [...requirementsSteps];
}
